/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../components/Modal';
import ManageCard from '../../screens/Card/manageCard';
import { manageCardScreens } from '../../screens/Card/constants';
import PinSettings from '../../screens/Card/pinSettings';
import ViewPin from '../../screens/Card/viewPin';
import TransactionState from '../../screens/Card/transactionState';
import CardFees from '../../screens/Card/CardFees';
import downloadFile from '../../utilities/downloadFile';
import { useSetting } from '../../utilities/sharedHooks/settings';

const CardSettingsModal = ({
  hide,
  cardStatus,
  cardProvider,
  enableCryptodraft,
  openCryptodraftModal,
  defaultScreen,
}) => {
  const [currentScreen, setCurrentScreen] = useState(defaultScreen);
  const [pinValue, setPinValue] = useState();

  const [newPdfEndpointEnabled] = useSetting('server_configurations', 'pdf_service_feature_toggle');

  const manageCardFlow = useMemo(
    () => [
      {
        screen: manageCardScreens.MAIN,
        component: (
          <ManageCard
            cardStatus={cardStatus}
            cardProvider={cardProvider}
            openScreen={setCurrentScreen}
            enableCryptodraft={enableCryptodraft}
            openCryptodraftModal={openCryptodraftModal}
          />
        ),
      },
      {
        screen: manageCardScreens.PIN_SETTINGS,
        component: <PinSettings setPin={setPinValue} openScreen={setCurrentScreen} />,
      },
      {
        screen: manageCardScreens.VIEW_PIN,
        component: <ViewPin pin={pinValue} openScreen={setCurrentScreen} />,
      },
      {
        screen: manageCardScreens.STATEMENT_OF_TRANSACTIONS,
        component: (
          <TransactionState
            openScreen={setCurrentScreen}
            cardProvider={cardProvider}
            downloadFile={downloadFile}
            newPdfEndpointEnabled={newPdfEndpointEnabled}
          />
        ),
      },
      {
        screen: manageCardScreens.CARD_FEES,
        component: <CardFees openScreen={setCurrentScreen} cardProvider={cardProvider} />,
      },
    ],
    [cardStatus, cardProvider, enableCryptodraft, pinValue, currentScreen]
  );

  const SelectedComponent = useMemo(
    () => manageCardFlow.find((item) => item.screen === currentScreen).component,
    [manageCardFlow, currentScreen]
  );

  const isPINSettings =
    currentScreen === manageCardScreens.PIN_SETTINGS ||
    currentScreen === manageCardScreens.VIEW_PIN;

  return (
    <ModalRoot>
      <Modal
        contentStyle={{
          maxHeight: isPINSettings ? '25rem' : '',
        }}>
        <ModalHeader>
          <i
            onClick={(e) => {
              e.target.closest('html').classList.remove('overflow-hidden');
              hide();
            }}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

export default CardSettingsModal;
CardSettingsModal.propTypes = {
  hide: PropTypes.func,
  cardStatus: PropTypes.object.isRequired,
  cardProvider: PropTypes.string.isRequired,
  defaultScreen: PropTypes.string,
  enableCryptodraft: PropTypes.bool,
  openCryptodraftModal: PropTypes.func,
};

CardSettingsModal.defaultProps = {
  hide: null,
  enableCryptodraft: false,
  openCryptodraftModal: null,
  defaultScreen: manageCardScreens.MAIN,
};
